import { createFileRoute } from '@tanstack/react-router';
import z from '@/lib/zod';
import { PasswordReset } from '@/pages/password-reset';

// Rotta pubblica: il token nel link è la prova di identità.
export const Route = createFileRoute('/password-reset')({
  component: PasswordReset,
  validateSearch: z.object({ token: z.string().nullish() }),
});
